import Vue from 'vue'
import Vuex from 'vuex'
import i18n from '@/i18n'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
        snackbar:{},
        Hargasebenaranggaran: [
            { "id": "1", "desc": i18n.t("pilihanhargasebenar")},
            { "id": "2", "desc": i18n.t("pilihanhargaanggaran")},
        ],
        localStorageuser: [],
    },
	getters: {},
	mutations: {
        SET_SNACKBAR(state, snackbar){
            state.snackbar = snackbar
        },
        SET_LOCALSTORAGEUSER(state, localStorageuser) {
            state.localStorageuser = localStorageuser
        },
    },
    actions:{
        setSnackbar({commit}, snackbar){
            commit('SET_SNACKBAR', snackbar)
        },
        localStorageuser({ commit }) {
            commit('SET_LOCALSTORAGEUSER', JSON.parse(localStorage.getItem('user')))
        },
    },
    modules:{}
})